export default __webpack_public_path__ + "static/media/bb-logo.8566c11e.png";